import Axios from "axios";
import {getUploadUrl} from "../../../../utils/baseUrl";

export const handleDownload = (name, nameOrig) => {
    // Téléchargement des fichier via un requête axios
    Axios({
        method: "get",
        url: `${getUploadUrl()}/documents/${name}`,
        responseType: "arraybuffer",
    })
        .then((response) => {
            // on créer un élément à la volée
            var link = document.createElement("a");

            if (window["ReactNativeWebView"]) {
                // Dans le cas de la webview React-Native, on assigne l'url de la réponse à la propriété href
                link.href = response.config.url;
            } else {
                // Sinon on créé une chaine contenant l'URL représentant l'objet passé en paramètre
                // https://developer.mozilla.org/fr/docs/Web/API/URL/createObjectURL
                link.href = window.URL.createObjectURL(
                    new Blob([response.data], {type: "application/octet-stream"})
                );
            }
            // Download du fichier
            link.download = nameOrig;
            // On ajoute le fichier au DOM
            document.body.appendChild(link);
            // On clique pour lancer le téléchargement
            link.click();

            // On révoque l'objet URL pur effacer la référence à cet objet stocké par le navigateur
            // https://developer.mozilla.org/fr/docs/Web/API/URL/revokeObjectURL
            setTimeout(function () {
                window.URL.revokeObjectURL(link);
            }, 200);
        });
};